import React, {useEffect} from 'react';
import styles from './Modal.module.css';
import {FaTimes} from "react-icons/fa";

function ModalNotif({ children, onClose, timeout, className = ''}) {
    const handleOverlayClick = () => {
        onClose();
    };

    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    const modalClasses = `${styles.modalNotif} ${className}`;

    return (
        <div className={styles.modalNotifBackdrop} onClick={handleOverlayClick}>
            <div className={modalClasses} onClick={handleContentClick}>
                {children}
            </div>
        </div>
    );
}

export default ModalNotif;
